<template>
  <div>
    <p :class="{'linked-title':!isCorrelateModal}">
      {{ selectedRelation }}
      <span class="selected-ques-num">{{ modalData.question.length }}</span>
      <a class="title-edit-btn" @click="editTitle"></a>
    </p>
    <div :class="{'flex-overall-arrange':isCorrelateModal}">
      <div class="rank-box-flex"
        :style="correlatedHeight"
        :class= stowRankStyle
        ref="checkedQuestionRef"
      >
        <div class="rank-selected-linked-box" @mouseover="mouseOverHandler(index)" @mouseout="mouseOutHandler" v-for="(item, index) in modalData.question" :key="item.questionId">
          <span class="selected-linked-ele-question" v-show="!isTitleEditing">{{ item.questionText }}
            <i class="el-icon-error question-delete-icon" v-show="isHover == index" @click="deleteHandle(index)" @keypress="keyPressHandler" @blur="emitEditEvent"/>
          </span>
          <span v-if="isTitleEditing">
            <input class="selected-linked-input" :ref="'titleInput'+index" v-model="item.questionText" :size="inputSize(item.questionText)"/>
          </span>
        </div>
      </div>
      <span v-if="isCorrelateModal && isMultiLine" class="whole-or-stow" @click="wholeOrStowClick">{{ wholeOrStowTxt }}<i style="margin-left:5px" :class="wholeOrStowIcon" /></span>
    </div>
    <p class="linked-question-txt" :class="{'linked-title': !isCorrelateModal}">{{ isCorrelateModal ? relatedPlease : relatedSearch }}</p>
  </div>
</template>

<script>
export default {
  name: "AssociateQuery",
  props: ['modalData', 'isCorrelateModal', 'isSpreadMulLine'],
  data(){
    return {
      isTitleEditing: false, // 是否是编辑状态
      isHover: -1,
      multiLineHeight: "",
      isSpreadMultiLine: false, //是否点击展开
      isMultiLine: false, //是否为多行
    }
  },
  mounted(){
    this.checkedQuesIsMoreOneLine();
  },
  computed: {
    selectedRelation() {
      return this.$t("zhiji.common.selectedRelatedQues");
    },
    relatedSearch() {
      return this.$t("zhiji.common.pleaseSearchRelateQues");
    },
    relatedPlease() {
      return this.$t("zhiji.common.pleaseRelateOne");
    },
    stowRankStyle(){
      return this.isCorrelateModal ? this.isSpreadMultiLine ? 'stow-rank-box' : 'rank-box-flex-one' : '';
    },
    wholeOrStowTxt() {
      return this.isSpreadMultiLine ? this.$t("zhiji.common.stow") : this.$t("zhiji.common.whole");
    },
    wholeOrStowIcon() {
      return this.isSpreadMultiLine ? "el-icon-arrow-up" : "el-icon-arrow-down";
    },
    inputSize() {
      return text => {
        let sizeLength = 0;
        for (let i = 0; i < text.length; i++) {
          const code = text.charCodeAt(i);
          if (code > 255) {
            sizeLength += 2;
          } else if(code > 64 && code < 91) {
            sizeLength += 1.5;
          } else {
            sizeLength++;
          }
        }
        return sizeLength <= 130 ? sizeLength : 130;
      }
    },
    correlatedHeight() {
      if (!this.isCorrelateModal) {
        return {};
      } else {
        return { "max-height": this.multiLineHeight };
      }
    },
  },
  methods:{
    // 已选择的相似问题是否超过一行
    checkedQuesIsMoreOneLine() {
      if (!this.isCorrelateModal) {
        return;
      }
      const REF = this.$refs.checkedQuestionRef;
      if (REF && REF.offsetHeight > 35) {
        this.isMultiLine = true;
        this.multiLineHeight = "32px";
      }
    }, 
    wholeOrStowClick() {
      this.isSpreadMultiLine = !this.isSpreadMultiLine;
      this.multiLineHeight = this.isSpreadMultiLine ? "100px" : "31px";
    },
    editTitle() {
      this.isTitleEditing = true;
      this.$nextTick(() => {
        this.$refs.titleInput && this.$refs.titleInput[0].focus();
      });
    },
    emitEditEvent() {
      this.isTitleEditing = false;
    },
    keyPressHandler(event) {
      const isEnterKey = event.keyCode === 13;
      isEnterKey && this.emitEditEvent();
    },
    mouseOverHandler(index) {
      this.isHover = index;
    },
    mouseOutHandler() {
      this.isHover = -1;
    },
    deleteHandle(index) {
      if (this.modalData.question.length > 2) {
        this.modalData.question.splice(index, 1);
      } else if(this.modalData.question.length === 1) {
        this.showTipsModal(this.$t("zhiji.common.selectedQuesNumBlank"), "warning");
      } else {
        this.showTipsModal(this.$t("zhiji.common.selectedQuesNumError"), "warning");
      }
    },
    showTipsModal(message, type){
      this.$message({
          message: message,
          center: true,
          duration: 2000,
          type: type
      });
    },
  }
}
</script>

<style lang="less" scoped>
p.linked-title {
  font-weight: bold;
  font-size: 17px;
  margin-top: 70px;
}
.selected-ques-num {
  margin-left: 5px;
  color: #56e9ce;
  font-weight: bold;
  font-size: 14px;
}
.title-edit-btn {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: 0 5px 0 5px;
  vertical-align: -3px;
  background: url("@{zhijiStaticImagePath}class-spr.png") -76px 0;

  &:hover {
      background-position: -76px -22px;
  }
}
.rank-box-flex {
  display: flex;
  flex-wrap: wrap;
  width: 720px;
  max-height: 190px;
  overflow: auto;
}
.rank-selected-linked-box {
  position: relative;
}
.selected-linked-ele-question {
  box-sizing: border-box;
  display: inline-block;
  padding: 2px 4px;
  margin-top: 8px;
  margin-right: 8px;
  border-radius: 4px;
  border: 1px solid #eee;
  background-color: #cde4f24a;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; 
  max-width: 710px;
}
.question-delete-icon {
  position: absolute;
  right: 0px;
  top: 5px;
}
.selected-linked-input {
  border: 1.5px solid #ccc;
  margin-top: 5px;
  margin-right: 4px;
  padding: 1px 3px;
  border-radius: 3px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  max-width: 700px;
}
.linked-question-txt {
  margin-bottom: 10px;
  margin-top: 20px;
}
.flex-overall-arrange {
  display: flex;
  align-items: flex-end;
}
.rank-box-flex-one {
  width: 868px;
  overflow: hidden;
}
.stow-rank-box {
  width: 868px;
  overflow: auto;
}
.whole-or-stow {
  color: #2ec2ff;
}
</style>